var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('questions',{attrs:{"currentQuestion":_vm.currentQuestion,"currentStep":_vm.step},on:{"nextQuestion":function($event){return _vm.checkNextQuestion($event.question)},"previousQuestion":function($event){return _vm.changeToPrevious($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }